"use client";

import * as React from "react";

import { VerticalLayout } from "./vertical/vertical-layout";

export function Layout(props) {
	return <VerticalLayout {...props} />;
}
